import { getI18n } from '@mimir/common/i18n/initializeI18n';
import { getGlobalRouter } from '@mimir/web/router';
import { initializeGlobalStore } from './store/initializeGlobalStore';

/**
 * The i18n, store and router that the main application root is built from,
 * for `createAppRoot` in `initializeVue2.ts` and `initializeVue3.ts`.
 *
 * i18next is initialized once per page by `initializeI18n()`, which the caller
 * must have awaited. Call this at most once per page: `initializeGlobalStore()`
 * builds a new store over the shared `initialState` object and replaces the
 * global store accessor's store, so a second call would leave two stores
 * sharing one state. The router is the module-level one from `getGlobalRouter()`.
 */
export function createAppServices() {
  return { i18next: getI18n(), store: initializeGlobalStore(), router: getGlobalRouter() };
}
